import {
  MaterialReactTable,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleFullScreenButton,
} from "material-react-table";
import { useState } from "react";
import { Fragment } from "react";
import { useEffect } from "react";
import { useMemo, useRef } from "react";
import { connect } from "react-redux";

import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/FilterAltOff";
import ClearSortingIcon from "@mui/icons-material/MobiledataOff";
import SendIcon from "@mui/icons-material/Send";
import DashboardIcon from "@mui/icons-material/Troubleshoot";
import ViewIcon from "@mui/icons-material/Visibility";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import { useSnackbar } from "notistack";

import { getCampaign } from "../../data/omniDataAPI";
import * as AdminSessionActions from "../../state/redux/adminSession";
import {
  createOmniPaginationObject,
  formatIsoDateString,
  helperGetIsoDate,
} from "../../utils/helpers";
import OmniGridButton from "../ui/omniGridButton";

const calculateColumns = () => {
  //default case
  return [
    {
      accessorKey: "_id",
      header: "ID",
      size: 150,
      enableColumnFilterModes: false,
    },
    // {
    //   accessorKey: "omniAudit.createdDate",
    //   enableColumnFilterModes: false,
    //   header: "Created",
    //   size: 125,

    //   muiTableHeadCellProps: {
    //     align: "center",
    //   },
    //   muiTableBodyCellProps: {
    //     align: "center",
    //   },
    //   enableColumnFilter: false,
    //   //custom conditional format and styling
    //   Cell: ({ cell }) => <Box component="span">{`${formatIsoDateString(cell.getValue())}`}</Box>,
    // },
    {
      accessorKey: "omniData.description",
      header: "Campaign",
      enableColumnFilterModes: false,
      enableSorting: false,
      grow: true,
    },
    {
      accessorKey: "omniData.initialCount",
      header: "Size",
      enableColumnFilterModes: false,
      size: 125,
      enableColumnFilter: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "omniData.sendDate",
      enableColumnFilterModes: false,
      header: "Send On",
      size: 125,

      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableColumnFilter: false,
      //custom conditional format and styling
      Cell: ({ cell }) => (
        <Box
          component="span"
          // sx={theme => ({
          //   color: cell.getValue() ? theme.palette.error.main : theme.palette.error.main,
          // })}
        >{`${cell.getValue() ? formatIsoDateString(cell.getValue()) : "-"}`}</Box>
      ),
    },
    {
      accessorKey: "omniRelationships.relatedData",
      header: "Sent",
      enableColumnFilterModes: false,
      enableColumnFilter: false,
      enableSorting: false,
      size: 125,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      // Cell: ({ cell }) => <Box component="span">{`x${cell.getValue().length}`}</Box>,

      Cell: ({ cell }) => (
        <Box
          component="span"
          sx={theme => ({
            backgroundColor:
              cell.getValue().length > 0 ? theme.palette.success.main : theme.palette.info.main,
            borderRadius: "0.25rem",
            color: "#fff",
            maxWidth: "14ch",
            minWidth: "14ch",
            p: "0.25rem",
          })}
        >
          {cell.getValue().length > 0 ? `x${cell.getValue().length}` : "-"}
        </Box>
      ),
    },
  ];
};

const getInitialState = () => {
  return {
    density: "compact",
    columnVisibility: {
      _id: false,
      //   "omniData.givenName": true,
    },
  };
};

export const CommunicationRequests = props => {
  const {
    communicationRequestODMs,
    onEditCommunicationRequest = null,
    onRequestNewPage = null,
    onSendHandler = null,
    isLoading = false,
    communicationRequestPagination = createOmniPaginationObject,
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const mobileLayout = useMediaQuery(theme.breakpoints.down("sm"));
  const tableContainerRef = useRef(null); //we can get access to the underlying TableContainer element and react to its scroll events

  const columns = useMemo(() => calculateColumns(), []);
  const initialState = useMemo(() => getInitialState(), []);

  const [rowCount, setRowCount] = useState(0);

  useEffect(() => {
    if (communicationRequestPagination != null) {
      setPagination({
        pageIndex: communicationRequestPagination.pageIndex - 1,
        pageSize: communicationRequestPagination.pageSize,
      });
      setRowCount(communicationRequestPagination.totalItems);
    }
  }, [communicationRequestPagination]);

  const [sorting, setSorting] = useState([]);

  const [columnFilters, setColumnFilters] = useState([]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  useEffect(() => {
    let newQuery = {};
    columnFilters.forEach((element, index) => {
      if (element.id === "omniAudit.createdDate") {
        const min = parseInt(element.value[0]);
        const max = parseInt(element.value[1]);
        if (!isNaN(min)) {
          let theDateSring = helperGetIsoDate(min);

          newQuery[element.id] = {
            "#lte": theDateSring,
          };
        }
        if (!isNaN(max)) {
          let theDateSring = helperGetIsoDate(max);

          newQuery[element.id] = {
            "#lte": theDateSring,
          };
        }
      } else {
        newQuery[element.id] = {
          "#regex": `${element.value}`,
          "#options": "i",
        };
      }
    });

    let newSorting = {};
    sorting.forEach(element => {
      newSorting[element.id] = element.desc ? -1 : 1;
    });

    if (
      communicationRequestPagination &&
      (pagination.pageIndex + 1 !== communicationRequestPagination.pageIndex ||
        pagination.pageSize !== communicationRequestPagination.pageSize ||
        JSON.stringify(pagination.query) !== JSON.stringify(columnFilters))
    ) {
      let newPage = createOmniPaginationObject(communicationRequestPagination);
      newPage.pageIndex = pagination.pageIndex + 1;
      newPage.pageSize = pagination.pageSize;
      newPage.query = newQuery;
      newPage.sort = newSorting;

      onRequestNewPage(newPage);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnFilters, sorting, pagination.pageIndex, pagination.pageSize]);

  if (communicationRequestODMs == null) {
    return <Fragment></Fragment>;
  }

  return (
    <MaterialReactTable
      layoutMode="grid"
      columns={columns}
      data={communicationRequestODMs}
      initialState={initialState}
      defaultColumn={{
        minSize: 20, //allow columns to get smaller than default
        maxSize: 9001, //allow columns to get larger than default
        size: 100, //make columns wider by default
        grow: false,
      }}
      state={{
        columnFilters,
        isLoading,
        pagination,
        sorting,
      }} //pass our managed row selection state to the table to use
      //pagination
      manualPagination={true}
      onColumnFiltersChange={setColumnFilters}
      onPaginationChange={setPagination}
      manualSorting
      manualFiltering
      onSortingChange={setSorting}
      //header
      enableColumnActions={false}
      enableStickyHeader={true}
      enableColumnFilterModes={true}
      filterFns={{
        customFilterFn: (row, id, filterValue) => {
          return row.getValue(id) === filterValue;
        },
      }}
      muiTableHeadCellFilterTextFieldProps={{
        sx: {
          "& .MuiInputBase-input": { padding: "6px" },

          "& .MuiInputBase-root": { paddingRight: "0px" },
          "& .MuiSelect-iconOutlined": { marginRight: "0.75rem" },
          width: "100%",
        },
        variant: "outlined",
      }}
      //row
      enableRowActions={true}
      enableRowSelection={false}
      getRowId={originalRow => originalRow._id}
      rowCount={rowCount}
      positionToolbarAlertBanner="bottom"
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      muiTopToolbarProps={{
        sx: {
          backgroundColor: theme.palette.commonground.main,
          color: theme.palette.secondary.main,
        },
      }}
      muiBottomToolbarProps={{
        sx: {
          backgroundColor: theme.palette.commonground.main,
          color: theme.palette.commonground.contrastText,
        },
      }}
      muiTablePaperProps={{
        sx: {
          boxShadow: "none",
        },
      }}
      muiTableContainerProps={{
        ref: tableContainerRef, //get access to the table container element
        sx: mobileLayout
          ? {
              minHeight: "564px",
              maxHeight: "564px",
              backgroundColor: theme.palette.commonground.main,
              color: theme.palette.commonground.main,
              borderLeft: `1px solid ${alpha(theme.palette.commonground.contrastText, 0.25)}`,
              borderRight: `1px solid ${alpha(theme.palette.commonground.contrastText, 0.25)}`,
            }
          : {
              minHeight: "298px",
              maxHeight: "298px",
              backgroundColor: theme.palette.commonground.main,
              color: theme.palette.commonground.main,
              border: `solid 0.5px ${theme.palette.divider}`,
            },
      }}
      muiTableProps={{
        sx: {
          backgroundColor: theme.palette.commonground.main,
          color: theme.palette.commonground.main,
        },
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: alpha(theme.palette.commonground.contrastText, 0.25),
          color: theme.palette.commonground.contrastText,
          justifyContent: "start",
        },
      }}
      renderRowActions={({ row }) => (
        <Box
          sx={{
            display: "flex",
            flexWrap: "nowrap",
            gap: "2px",
            padding: 0,
            marginRight: "8px",
          }}
        >
          <OmniGridButton
            key="edit"
            sx={{ ...(onEditCommunicationRequest == null && { display: "none" }) }}
            onClick={() => {
              onEditCommunicationRequest(row.original);
            }}
            icon={
              row.original.omniRelationships.relatedData.length === 0 ? (
                <EditIcon fontSize="small" />
              ) : (
                <ViewIcon fontSize="small" />
              )
            }
          />

          {row.original.omniRelationships.relatedData.length > 0 && (
            <OmniGridButton
              key="send"
              onClick={() => {
                //load and navigate
                getCampaign(row.original.omniRelationships.relatedData[0]._id).then(theResult => {
                  if (theResult != null && theResult.omniData.dashboard_url != null) {
                    window.open(theResult.omniData.dashboard_url, "_blank", "noreferrer");
                  } else {
                    enqueueSnackbar("Unable to load results.", {
                      variant: "error",
                    });
                  }
                });
              }}
              icon={<DashboardIcon fontSize="small" />}
            />
          )}

          {row.original.omniRelationships.relatedData.length === 0 && (
            <OmniGridButton
              key="send"
              onClick={() => {
                onSendHandler(row.original);
              }}
              icon={<SendIcon fontSize="small" />}
            />
          )}
        </Box>
      )}
      renderToolbarInternalActions={({ table }) => (
        <Box>
          {sorting.length > 0 && (
            <Tooltip title="Clear All Sorting" arrow>
              <IconButton
                sx={{ color: theme.palette.secondary.main }}
                onClick={() => {
                  setSorting([]);
                }}
              >
                <ClearSortingIcon />
              </IconButton>
            </Tooltip>
          )}
          {columnFilters.length > 0 && (
            <Tooltip title="Clear All Filters" arrow>
              <IconButton
                sx={{ color: theme.palette.secondary.main }}
                onClick={() => {
                  setColumnFilters([]);
                }}
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          )}

          {/* eslint-disable react/jsx-pascal-case*/}
          {/* <MRT_ToggleGlobalFilterButton table={table} /> */}
          <MRT_ToggleFiltersButton table={table} />
          <MRT_ShowHideColumnsButton table={table} />
          <MRT_ToggleFullScreenButton table={table} />
          {/* eslint-enablereact/jsx-pascal-case */}
        </Box>
      )}
    />
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  createReportRequest: AdminSessionActions.createReportRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(CommunicationRequests);
